import { diacriticsReplacements, specialCharReplacements } from './replacements.js';

const escapeStringRegexp = (str) => {
  const matchOperatorsRegex = /[|\\{}()[\]^$+*?.]/g;

  if (typeof str !== 'string') {
    throw new TypeError('Expected a string');
  }

  return str.replace(matchOperatorsRegex, '\\$&');
};

const doCustomReplacements = (string, replacements) => {
  for (const [key, value] of replacements) {
    string = string.replace(new RegExp(escapeStringRegexp(key), 'g'), value);
  }

  return string;
};

/**
 * Transliterate a string to remove diacritics
 * Based on https://github.com/sindresorhus/transliterate
 * @param {string} string The string to transliterate
 * @param {Object} options The options object
 * @param {Array<[string, string]>} options.customReplacements Custom replacements to apply
 * @param {boolean} options.removeSpecialCharacters Whether to remove special characters
 * @returns {string} The transliterated string
 */
export default function transliterate(string, options) {
  if (typeof string !== 'string') {
    throw new TypeError(`Expected a string, got \`${typeof string}\``);
  }

  options = {
    customReplacements: [],
    ...options
  };

  const customReplacements = new Map([
    ...diacriticsReplacements,
    ...(options.removeSpecialCharacters ? specialCharReplacements : []),
    ...options.customReplacements
  ]);

  string = string.normalize();
  string = doCustomReplacements(string, customReplacements);
  string = string.normalize('NFD').replace(/\p{Diacritic}/gu, '').normalize();

  return string;
}
